export enum EnumTipoPerfil {
  Facturacion = 1,
  LeadEstandar,
  LeadPersonalizado
}
